import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { slugify } from "../../custom_utils/helpers";
import { ImageBlock } from "./image_block";
import { LinkButton } from "./library/button";
export const FeaturedContentBlock = (props)=>/*#__PURE__*/ _jsxs("div", {
        className: "featured-content-block",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "featured-content-block__text",
                children: [
                    /*#__PURE__*/ _jsxs("header", {
                        className: "featured-content-block__header",
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                "data-anchor": slugify(props.title),
                                className: "featured-content-block__title title--l",
                                children: props.title
                            }),
                            /*#__PURE__*/ _jsxs("p", {
                                className: "featured-content-block__label",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "sr-text",
                                        children: "Categorie: "
                                    }),
                                    "Uitgelicht"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        dangerouslySetInnerHTML: {
                            __html: props.html
                        }
                    }),
                    /*#__PURE__*/ _jsx("footer", {
                        className: "featured-content-block__footer",
                        children: /*#__PURE__*/ _jsx(LinkButton, {
                            variant: "black",
                            route: props.linkUrl,
                            children: props.linkTitle
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "featured-content-block__image",
                children: /*#__PURE__*/ _jsx(ImageBlock, {
                    imageUrl: props.imageUrl,
                    imageUrlFallback: props.imageUrlFallback,
                    imageAlt: props.imageAlt
                })
            })
        ]
    });
